import { isInExperimentGroup } from '../../GigCardListings/ListingsTransformer/abTestsTransformer';
import { ALLOCATIONS, EXPERIMENTS } from '../../constants/experiments';
import { RATING_PRECISION_FLOOR, RATING_PRECISION_CEILING, FULL_SCORE_EXCEPTIONS } from './constants';

const ONE_DECIMAL_PRECISION = { minimumFractionDigits: 1, maximumFractionDigits: 1 };
const TWO_DECIMAL_PRECISION = { minimumFractionDigits: 1, maximumFractionDigits: 2 };

const isFullScoreException = (rating) => FULL_SCORE_EXCEPTIONS.some((exception) => Math.abs(rating - exception) < 1e-6);

const isEligibleForTwoDecimals = (rating) =>
    rating >= RATING_PRECISION_FLOOR && rating <= RATING_PRECISION_CEILING && !isFullScoreException(rating);

/**
 * Decides the rating display precision for the COBRAS_PUBLIC_RATING_VARIANCE test (DR: public_rating_variance).
 * Variant B: 2 decimals for ratings 4.61-5.00, except .70/.80/.90/5.00 which stay 1 decimal.
 * Control / not allocated / below 4.61: 1 decimal, unchanged from today's behavior.
 */
export const getRatingPrecision = (rating, abTests = {}) => {
    const isInTestVariant = isInExperimentGroup(
        EXPERIMENTS.COBRAS_PUBLIC_RATING_VARIANCE,
        [ALLOCATIONS.TEST_B],
        abTests
    );

    if (!isInTestVariant || !isEligibleForTwoDecimals(rating)) {
        return ONE_DECIMAL_PRECISION;
    }

    return TWO_DECIMAL_PRECISION;
};
